import { useEffect } from "react";
// my imports:
import { GameManager } from "@/app/lib/game-state/game-manager";
import Nav from "@/app/lib/input/nav";
import UI from "@/app/lib/ui/ui";

export function useAutoFocus(gameManager: GameManager, ui: UI) {

    const activeGame = gameManager.active;
   
   // once on mount, start the cursor at the earliest empty slot
    useEffect(() => {

        /* Now that focus doesn't bring up keyboard, it is okay
        * that we start with focus on mobile.
        if (ui.isMobile) {
            ui.defocusAll()
            return;
        }
        */

        if (ui.path === '/tutorial') {
            ui.defocusAll()
            return;
        }

        // initialize a nav (the constructor parameters don't matter here)
        const nav = new Nav(0, 0, activeGame.state);
        const earliestEmptySlot = nav.findEarliestEmptySlot();
        if (!earliestEmptySlot)
            return;

        // focus it
        // a slight delay allows it to process after the render updates from changing level/mode
        setTimeout(() => {
            ui.focus(earliestEmptySlot);
        }, 0);
    }, [
        ui.isTouch, 
        ui.path,
        ui.autoFocusRequestSignal,
        gameManager.activeMode, 
        gameManager.story.state.levelNumber,
        gameManager.pyramid.state.seedWord,
        ui.isLoaded
    ]);
}